import { useTranslation } from 'react-i18next';

interface IProps {
  children: React.ReactNode;
}

type BodyType = React.FC<IProps>;
type TitleType = React.FC<{ children?: React.ReactNode; title: string }>;
type MeasurementOverviewLayoutCmp = React.FC<IProps> & {
  Title: TitleType;
  Body: BodyType;
};

const Title: TitleType = ({ children, title }) => {
  const { t } = useTranslation();
  return (
    <div className="relative flex flex-col gap-4 pt-10 md:flex-row md:items-center md:justify-between">
      <h1 className="text-4xl font-bold uppercase ">{t(title)}</h1>
      {children}
    </div>
  );
};

const Body: BodyType = ({ children }) => {
  return <div className="flex flex-col gap-6 mt-6 md:flex-row">{children}</div>;
};

const MeasurementOverviewLayout: MeasurementOverviewLayoutCmp = ({ children }) => {
  return <div className="pt-24 md:pt-40 md:mb-24">{children}</div>;
};

MeasurementOverviewLayout.Title = Title;
MeasurementOverviewLayout.Body = Body;
export { MeasurementOverviewLayout };
